export default __webpack_public_path__ + "static/1-f6a99454779addac2f9db760c57d5684.png";